import { Component, OnInit } from '@angular/core';
import { faPrint, faChartBar } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'odl-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    currentYear = 2019;

    faPrint = faPrint;
    faStats = faChartBar;

    constructor() {
        const date = new Date();
        this.currentYear = date.getFullYear();
    }

    ngOnInit() {
    }

}
